import React, { useEffect } from 'react'
import FeedbackBlock from '../../../partials/FeedbackBlock';
import Button from '../../../partials/Button/Button';
import PayloadSVG from "./SVG/PayloadSVG";
import Scroll from '../../../partials/Scroll/Scroll';

const PayloadParts = (props) => {

    const { allParts, parts, button, deployed, status='default', feedback, caption, children } = props

    useEffect(()=>{

    },[])


    return (
        <FeedbackBlock
            status={status ? status : 'default'}
            caption={caption}
            className="simulation-block"
            feedback={feedback} >
            <Scroll>
                {children}
            </Scroll>
            <PayloadSVG allparts={allParts} parts={parts} deployed={deployed} />
            {button && <Button
                disabled={button.disabled}
                className={'small primary'}
                onClick={button.onClick}
                text={button.text}
            />}
        </FeedbackBlock>
    )

}

export default  PayloadParts;
